import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import {TreeListItem} from '../../interfaces/tree-list-item.model';
import {StudiesService} from '../../services/studies.service';

@Component({
  selector: 'app-calculation-chamber-detail',
  templateUrl: './calculation-chamber-detail.component.html',
  styleUrls: ['./calculation-chamber-detail.component.scss']
})
export class CalculationChamberDetailComponent implements OnInit {
  study: any = { recommendations: [] };
  navbarData: any = { title: '-', color: 6, data: [] };
  progressEmoji: string[] = ['/assets/img/icon-smiley-red.svg', '/assets/img/icon-smiley-orange.svg', '/assets/img/icon-smiley-green.svg'];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private studiesService: StudiesService) { }

  ngOnInit() {
    this.route.params
      .switchMap((params: Params) => this.studiesService.get(+params['id']))
      .subscribe((a) => {
        this.study = a;

        this.navbarData = {
          title: `${a.title}`,
          color: 6,
          crumbs: [
            { text: 'Rekenkamer', link: '/rekenkamer' },
            { text: a.title, link: `/rekenkamer/${a.id}`, active: true }
          ],
          data: [
            // { title: 'Datum GS', value: a.dateGs, type: 'text' },
            { title: 'Datum PS', value: a.datePs, type: 'text' },
            { title: 'Portefeuillehouder', value: a.walletKeeper, type: 'text' },
            { title: 'Download rapport', value: a.url, type: 'file' }
          ]
        };

      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/calculation-chamber-detail/calculation-chamber-detail.component.ts